import MarkdownIt from 'markdown-it'

const handlePlugin = (plugin) => plugin.default || plugin

export default ({}, inject) => {
  const md = new MarkdownIt('commonmark', {"linkify":true,"breaks":true,"html":true,"injected":true,"xhtmlOut":false})

  inject('md', md)
}